//智慧停车
import Log from "../view/log";
import ParkingServiceNav from "../view/ParkingService/ParkingServiceNav";
import ParkOverView from "../view/ParkingService/ParkOverView/ParkOverView";
import ParkingDeviceManagement from "../view/ParkingService/ParkingDevice/ParkingDeviceManagement";
import ParkingDeviceAdd from "../view/ParkingService/ParkingDevice/ParkingDeviceAdd";
import ParkingDeviceCurrent from "../view/ParkingService/ParkingDevice/ParkingDeviceCurrent";
import ParkingDeviceModify from "../view/ParkingService/ParkingDevice/ParkingDeviceModify";
import EntAndExitManage from "../view/ParkingService/EntAndExitManage/EntAndExitManage";
import AuthorizationManagement from "../view/ParkingService/AuthorizationManagement/AuthorizationManagement";
import AuthorizationAdd from "../view/ParkingService/AuthorizationManagement/AuthorizationAdd";
import AuthorizationCurrent from "../view/ParkingService/AuthorizationManagement/AuthorizationCurrent";
import AuthorizationModify from "../view/ParkingService/AuthorizationManagement/AuthorizationModify";
import MonthlyVehicle from "../view/ParkingService/MonthlyVehicle/MonthlyVehicle";
import MonthlyVehicleAdd from "../view/ParkingService/MonthlyVehicle/MonthlyVehicleAdd";
import MonthlyVehicleModify from "../view/ParkingService/MonthlyVehicle/MonthlyVehicleModify";
import MonthlyVehicleRefund from "../view/ParkingService/MonthlyVehicle/MonthlyVehicleRefund";
import MonthlyVehicleRenew from "../view/ParkingService/MonthlyVehicle/MonthlyVehicleRenew";
import BlackListVehiclesManage from "../view/ParkingService/BlackListVehicles/BlackListVehiclesManage";
import BlackListVehiclesAdd from "../view/ParkingService/BlackListVehicles/BlackListVehiclesAdd";
import BlackListVehiclesModify from "../view/ParkingService/BlackListVehicles/BlackListVehiclesModify";
import WhiteListVehiclesManage from "../view/ParkingService/WhiteListVehicles/WhiteListVehiclesManage";
import WhiteListVehiclesAdd from "../view/ParkingService/WhiteListVehicles/WhiteListVehiclesAdd";
import WhiteListVehiclesModify from "../view/ParkingService/WhiteListVehicles/WhiteListVehiclesModify";
import EnterRecord from "../view/ParkingService/EnterRecord/EnterRecord";
import LPRRecord from '../view/ParkingService/LPRRecord/LPRRecord'
import ParkingBill from "../view/ParkingService/ParkingBill/ParkingBill";
import ParkingMonthBill from "../view/ParkingService/ParkingBill/ParkingMonthBill";
import ParkingCouponBill from "../view/ParkingService/ParkingBill/ParkingCouponBill";
import FreeCodeAuthor from "../view/ParkingService/ParkingOtherConfig/FreeCodeAuthor/FreeCodeAuthor";
import FreeCodeAuthorAdd from "../view/ParkingService/ParkingOtherConfig/FreeCodeAuthor/FreeCodeAuthorAdd";
import FreeCodeAuthorModify from "../view/ParkingService/ParkingOtherConfig/FreeCodeAuthor/FreeCodeAuthorModify";
import YardConfiguration from "../view/ParkingService/ParkingOtherConfig/YardConfiguration/YardConfiguration";
import VehiclesOnSite from "../view/ParkingService/VehiclesOnSite/VehiclesOnSite";
import VehiclesOnSiteAdd from "../view/ParkingService/VehiclesOnSite/VehiclesOnSiteAdd";
import VehiclesOnSiteModify from "../view/ParkingService/VehiclesOnSite/VehiclesOnSiteModify";
import DeviceStatusLog from "../view/ParkingService/DeviceStatusLog/DeviceStatusLog";
import CallPolice from "../view/ParkingService/CallPolice/CallPolice";
import AmountAllocation from "../view/ParkingService/AmountAllocation/AmountAllocation";
import AmountAdd from "../view/ParkingService/AmountAllocation/AmountAdd";
import AmountModify from "../view/ParkingService/AmountAllocation/AmountModify";
import MonthlyPayment from "../view/ParkingService/ParkingPayRecord/MonthlyPayment";
import TemporaryStop from "../view/ParkingService/ParkingPayRecord/TemporaryStop";
import CouponPayment from "../view/ParkingService/ParkingPayRecord/CouponPayment";
import ParkingServiceLog from "../view/ParkingService/ParkingServiceLog/ParkingServiceLog";
import ParkingMonthConfigCenter from "../view/ParkingService/ParkingConfig/ParkingMonthConfigCenter";
import ParkingMonthConfigModify from "../view/ParkingService/ParkingConfig/ParkingMonthConfigModify";
import ParkingMonthConfigUnCenter from "../view/ParkingService/ParkingConfig/ParkingMonthConfigUnCenter";
import ParkingMonthConfigUnModify from "../view/ParkingService/ParkingConfig/ParkingMonthConfigUnModify";
import ParkingTemporaryConfigCenter from "../view/ParkingService/ParkingConfig/ParkingTemporaryConfigCenter";
import ParkingTemporaryConfigModify from "../view/ParkingService/ParkingConfig/ParkingTemporaryConfigModify";
import DisplayManage from "../view/ParkingService/Display/DisplayManage";
import DisplayAdd from "../view/ParkingService/Display/DisplayAdd";
import DisplayModify from "../view/ParkingService/Display/DisplayModify";
import SentryBoxManage from "../view/ParkingService/SentryBox/SentryBoxManage";
import SentryBoxAdd from "../view/ParkingService/SentryBox/SentryBoxAdd";
import SentryBoxModify from "../view/ParkingService/SentryBox/SentryBoxModify";
import ParkingAliAccountAdd from "../view/ParkingService/CollectionAccount/aliAccountConfig/aliAccountAdd";
import ParkingAliAccountManage from "../view/ParkingService/CollectionAccount/aliAccountConfig/aliAccountManage";
import ParkingAliAccountModify from "../view/ParkingService/CollectionAccount/aliAccountConfig/aliAccountModify";
import ParkingWxAccountModify from "../view/ParkingService/CollectionAccount/wxAccountConfig/wxAccountModify";
import ParkingWxAccountAdd from "../view/ParkingService/CollectionAccount/wxAccountConfig/wxAccountAdd";
import ParkingWxAccountManage from "../view/ParkingService/CollectionAccount/wxAccountConfig/wxAccountManage";
import CouponPutOnTheShelves from "../view/ParkingService/ParkingCoupon/CouponPutOnTheShelves/CouponPutOnTheShelves";
import CouponPutOnTheShelvesAdd from "../view/ParkingService/ParkingCoupon/CouponPutOnTheShelves/CouponPutOnTheShelvesAdd";
import CouponPutOnTheShelvesModify from "../view/ParkingService/ParkingCoupon/CouponPutOnTheShelves/CouponPutOnTheShelvesModify";
import CouponSell from "../view/ParkingService/ParkingCoupon/CouponSell/CouponSell";
import CouponSellAdd from "../view/ParkingService/ParkingCoupon/CouponSell/CouponSellAdd";
import CouponRefund from "../view/ParkingService/ParkingCoupon/CouponRefund/CouponRefund";
import CouponRefundAdd from "../view/ParkingService/ParkingCoupon/CouponRefund/CouponRefundAdd";
import CouponUsageRecord from "../view/ParkingService/ParkingCoupon/CouponUsageRecord/CouponUsageRecord";
import CouponMerchantStatistics from "../view/ParkingService/ParkingCoupon/CouponMerchantStatistics/CouponMerchantStatistics";
import ParkingLotManage from "../view/ParkingService/ParkingLot/ParkingLotManage";
import ParkingLotAddOne from "../view/ParkingService/ParkingLot/ParkingLotAddOne";
import ParkingLotAddMany from "../view/ParkingService/ParkingLot/ParkingLotAddMany";
import ParkingLotModify from "../view/ParkingService/ParkingLot/ParkingLotModify";
import ParkingRent from "../view/ParkingService/ParkingRent/ParkingRent";
import ParkingRentAdd from "../view/ParkingService/ParkingRent/ParkingRentAdd";
import ParkingFeeRule from "../view/ParkingService/ParkingFeeRule/ParkingFeeRule";
import ParkingFeeRuleAdd from "../view/ParkingService/ParkingFeeRule/ParkingFeeRuleAdd";
import ParkingFeeRuleModify from "../view/ParkingService/ParkingFeeRule/ParkingFeeRuleModify";
import ParkingLotArea from "../view/ParkingService/ParkingLotArea/ParkingLotArea";
import ParkingLotAreaAdd from "../view/ParkingService/ParkingLotArea/ParkingLotAreaAdd";
import ParkingLotAreaModify from "../view/ParkingService/ParkingLotArea/ParkingLotAreaModify";
import FreeCodeRecord from "../view/ParkingService/FreeCodeRecord/FreeCodeRecord";
// import allowEnter from "../view/ParkingService/allowEnter/allowEnter";
// import disallowEnter from "../view/ParkingService/disallowEnter/disallowEnter";
import InnerConfiguration from "../view/ParkingService/ParkingOtherConfig/InnerConfiguration/InnerConfiguration";
import PersonnelOnDutyClassesManage from "../view/ParkingService/PersonnelOnDuty/PersonnelOnDutyClasses/PersonnelOnDutyClassesManage";
import PersonnelOnDutyClassesAdd from "../view/ParkingService/PersonnelOnDuty/PersonnelOnDutyClasses/PersonnelOnDutyClassesAdd";
import PersonnelOnDutyClassesModify from "../view/ParkingService/PersonnelOnDuty/PersonnelOnDutyClasses/PersonnelOnDutyClassesModify";
import PersonnelOnDutyScheduleManage from "../view/ParkingService/PersonnelOnDuty/PersonnelOnDutySchedule/PersonnelOnDutyScheduleManage";
import PersonnelOnDutyScheduleAdd from "../view/ParkingService/PersonnelOnDuty/PersonnelOnDutySchedule/PersonnelOnDutyScheduleAdd";
import PersonnelOnDutyScheduleModify from "../view/ParkingService/PersonnelOnDuty/PersonnelOnDutySchedule/PersonnelOnDutyScheduleModify";
import GuidanceScreenManage from '../view/ParkingService/GuidanceScreenManage/GuidanceScreenManage';
import GuidanceScreenAdd from '../view/ParkingService/GuidanceScreenManage/GuidanceScreenAdd';
import GuidanceScreenModify from '../view/ParkingService/GuidanceScreenManage/GuidanceScreenModify';

export default [
  /* 智慧停车 */
  {
    path: "/park_server/park_over_view",
    name: "park-over-view",
    components: {
      default: ParkingServiceNav,
      a: ParkOverView
    }
  },
  /* 智慧停车 */
  /* 设备管理 */
  {
    path: "/park_server/parking_device_management",
    name: "parking-device-management",
    components: {
      default: ParkingServiceNav,
      a: ParkingDeviceManagement
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/park_server/parking_device_add",
    name: "parking-device-add",
    components: {
      default: ParkingServiceNav,
      a: ParkingDeviceAdd
    }
  },
  {
    path: "/park_server/parking_device_current/:id",
    name: "parking-device-current",
    components: {
      default: ParkingServiceNav,
      a: ParkingDeviceCurrent
    }
  },
  {
    path: "/park_server/parking_device_modify/:id",
    name: "parking-device-modify",
    components: {
      default: ParkingServiceNav,
      a: ParkingDeviceModify
    }
  },
  {
    path: "/park_server/ent_and_exit_manage",
    name: "ent-and-exit-manage",
    components: {
      default: ParkingServiceNav,
      a: EntAndExitManage
    }
  },
  /* 设备管理 */

  /* 授权管理 */
  {
    path: "/park_server/authorization_management",
    name: "authorization-management",
    components: {
      default: ParkingServiceNav,
      a: AuthorizationManagement
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/park_server/authorization_add",
    name: "authorization-add",
    components: {
      default: ParkingServiceNav,
      a: AuthorizationAdd
    }
  },
  {
    path: "/park_server/authorization_current/:id",
    name: "authorization-current",
    components: {
      default: ParkingServiceNav,
      a: AuthorizationCurrent
    }
  },
  {
    path: "/park_server/authorization_modify/:id",
    name: "authorization-modify",
    components: {
      default: ParkingServiceNav,
      a: AuthorizationModify
    }
  },
  {
    path: "/park_server/monthly_vehicle",
    name: "monthly-vehicle",
    components: {
      default: ParkingServiceNav,
      a: MonthlyVehicle
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/park_server/monthly_vehicle_add",
    name: "monthly-vehicle-add",
    components: {
      default: ParkingServiceNav,
      a: MonthlyVehicleAdd
    }
  },
  {
    path: "/park_server/monthly_vehicle_modify/:id",
    name: "monthly-vehicle-modify",
    components: {
      default: ParkingServiceNav,
      a: MonthlyVehicleModify
    }
  },
  {
    path: "/park_server/monthly_vehicle_refund/:id",
    name: "monthly-vehicle-refund",
    components: {
      default: ParkingServiceNav,
      a: MonthlyVehicleRefund
    }
  },
  {
    path: "/park_server/monthly_vehicle_renew/:id",
    name: "monthly-vehicle-renew",
    components: {
      default: ParkingServiceNav,
      a: MonthlyVehicleRenew
    }
  },
  /* 授权管理 */
  {
    path: "/park_server/black_list_vehicles_manage",
    name: "black-list-vehicles-manage",
    components: {
      default: ParkingServiceNav,
      a: BlackListVehiclesManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/park_server/black_list_vehicles_add",
    name: "black-list-vehicles-add",
    components: {
      default: ParkingServiceNav,
      a: BlackListVehiclesAdd
    }
  },
  {
    path: "/park_server/black_list_vehicles_modify/:id",
    name: "black-list-vehicles-modify",
    components: {
      default: ParkingServiceNav,
      a: BlackListVehiclesModify
    }
  },
  {
    path: "/park_server/white_list_vehicles_manage",
    name: "white-list-vehicles-manage",
    components: {
      default: ParkingServiceNav,
      a: WhiteListVehiclesManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/park_server/white_list_vehicles_add",
    name: "white-list-vehicles-add",
    components: {
      default: ParkingServiceNav,
      a: WhiteListVehiclesAdd
    }
  },
  {
    path: "/park_server/white_list_vehicles_modify/:id",
    name: "white-list-vehicles-modify",
    components: {
      default: ParkingServiceNav,
      a: WhiteListVehiclesModify
    }
  },

  /* 进出记录 */
  {
    path: "/park_server/enter_record",
    name: "enter-record",
    components: {
      default: ParkingServiceNav,
      a: EnterRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/park_server/LPR_record',
    name: 'LPR-record',
    components: {
      default: ParkingServiceNav,
      a: LPRRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/park_server/parking_bill",
    name: "parking-bill",
    components: {
      default: ParkingServiceNav,
      a: ParkingBill
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/park_server/parking_month_bill",
    name: "parking-month-bill",
    components: {
      default: ParkingServiceNav,
      a: ParkingMonthBill
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/park_server/parking_coupon_bill',
    name: 'parking-coupon-bill',
    components: {
      default: ParkingServiceNav,
      a: ParkingCouponBill
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/park_server/yard_configuration",
    name: "yard-configuration",
    components: {
      default: ParkingServiceNav,
      a: YardConfiguration
    }
  },
  {
    path: "/park_server/inner_configuration",
    name: "inner-configuration",
    components: {
      default: ParkingServiceNav,
      a: InnerConfiguration
    }
  },
  {
    path: "/park_server/free_code_author",
    name: "free-code-author",
    components: {
      default: ParkingServiceNav,
      a: FreeCodeAuthor
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/park_server/free_code_author_add",
    name: "free-code-author-add",
    components: {
      default: ParkingServiceNav,
      a: FreeCodeAuthorAdd
    }
  },
  {
    path: "/park_server/free_code_author_modify/:id",
    name: "free-code-author-modify",
    components: {
      default: ParkingServiceNav,
      a: FreeCodeAuthorModify
    }
  },
  {
    path: "/park_server/vehicles_on_site",
    name: "vehicles-on-site",
    components: {
      default: ParkingServiceNav,
      a: VehiclesOnSite
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/park_server/vehicles_on_site_add",
    name: "vehicles-on-site-add",
    components: {
      default: ParkingServiceNav,
      a: VehiclesOnSiteAdd
    }
  },
  {
    path: "/park_server/vehicles_on_site_modify/:id",
    name: "vehicles-on-site-modify",
    components: {
      default: ParkingServiceNav,
      a: VehiclesOnSiteModify
    }
  },
  /* 进出记录 */

  /* 设备状态日志 */
  {
    path: "/park_server/device_status_log",
    name: "device-status-log",
    components: {
      default: ParkingServiceNav,
      a: DeviceStatusLog
    },
    meta: {
      keepAlive: true
    }
  },
  /* 设备状态日志 */

  /* 报警记录 */
  {
    path: "/park_server/call_police",
    name: "call-police",
    components: {
      default: ParkingServiceNav,
      a: CallPolice
    }
  },
  /* 报警记录 */
  {
    path: "/park_server/amount_allocation",
    name: "amount-allocation",
    components: {
      default: ParkingServiceNav,
      a: AmountAllocation
    }
  },
  {
    path: "/park_server/amount_add",
    name: "amount-add",
    components: {
      default: ParkingServiceNav,
      a: AmountAdd
    }
  },
  {
    path: "/park_server/amount_modify/:id",
    name: "amount-modify",
    components: {
      default: ParkingServiceNav,
      a: AmountModify
    }
  },
  {
    path: "/park_server/monthly_payment",
    name: "monthly-payment",
    components: {
      default: ParkingServiceNav,
      a: MonthlyPayment
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/park_server/coupon_payment",
    name: "coupon-payment",
    components: {
      default: ParkingServiceNav,
      a: CouponPayment
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/park_server/temporary_stop",
    name: "temporary-stop",
    components: {
      default: ParkingServiceNav,
      a: TemporaryStop
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/parking_server/parking_month_config_center",
    name: "parking-month-config-center",
    components: {
      default: ParkingServiceNav,
      a: ParkingMonthConfigCenter
    }
  },
  {
    path: "/parking_server/parking_month_config_modify",
    name: "parking-month-config-modify",
    components: {
      default: ParkingServiceNav,
      a: ParkingMonthConfigModify
    }
  },
  {
    path: "/parking_server/parking_month_config_un_center",
    name: "parking-month-config-un-center",
    components: {
      default: ParkingServiceNav,
      a: ParkingMonthConfigUnCenter
    }
  },
  {
    path: "/parking_server/parking_month_config_un_modify",
    name: "parking-month-config-un-modify",
    components: {
      default: ParkingServiceNav,
      a: ParkingMonthConfigUnModify
    }
  },
  {
    path: "/parking_server/parking_temporary_config_center",
    name: "parking-temporary-config-center",
    components: {
      default: ParkingServiceNav,
      a: ParkingTemporaryConfigCenter
    }
  },
  {
    path: "/parking_server/parking_temporary_config_modify",
    name: "parking-temporary-config-modify",
    components: {
      default: ParkingServiceNav,
      a: ParkingTemporaryConfigModify
    }
  },
  /* 智慧停车 */
  {
    path: "/park_server/parking_service_log",
    name: "parking-service-log",
    components: {
      default: ParkingServiceNav,
      a: ParkingServiceLog
    }
  },
  {
    path: "/park_server/display_manage",
    name: "display-manage",
    components: {
      default: ParkingServiceNav,
      a: DisplayManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/park_server/display_add",
    name: "display-add",
    components: {
      default: ParkingServiceNav,
      a: DisplayAdd
    }
  },
  {
    path: "/park_server/display_modify/:id",
    name: "display-modify",
    components: {
      default: ParkingServiceNav,
      a: DisplayModify
    }
  },
  {
    path: "/park_server/parking_lot_manage",
    name: "parking-lot-manage",
    components: {
      default: ParkingServiceNav,
      a: ParkingLotManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/park_server/parking_lot_add_one",
    name: "parking-lot-add-one",
    components: {
      default: ParkingServiceNav,
      a: ParkingLotAddOne
    }
  },
  {
    path: "/park_server/parking_lot_add_many",
    name: "parking-lot-add-many",
    components: {
      default: ParkingServiceNav,
      a: ParkingLotAddMany
    }
  },
  {
    path: "/park_server/parking_lot_modify/:id",
    name: "parking-lot-modify",
    components: {
      default: ParkingServiceNav,
      a: ParkingLotModify
    }
  },
  {
    path: '/park_server/guidance_screen_manage',
    name: 'guidance-screen-manage',
    components: {
      default: ParkingServiceNav,
      a: GuidanceScreenManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/park_server/guidance_screen_add',
    name: 'guidance-screen-add',
    components: {
      default: ParkingServiceNav,
      a: GuidanceScreenAdd
    }
  },
  {
    path: '/park_server/guidance_screen_modify/:id',
    name: 'guidance-screen-modify',
    components: {
      default: ParkingServiceNav,
      a: GuidanceScreenModify
    }
  },
  {
    path: "/park_server/parking_rent",
    name: "parking-rent",
    components: {
      default: ParkingServiceNav,
      a: ParkingRent
    }
  },
  {
    path: "/park_server/parking_rent_add",
    name: "parking-rent-add",
    components: {
      default: ParkingServiceNav,
      a: ParkingRentAdd
    }
  },
  {
    path: "/park_server/parking_fee_rule",
    name: "parking-fee-rule",
    components: {
      default: ParkingServiceNav,
      a: ParkingFeeRule
    }
  },
  {
    path: "/park_server/parking_fee_rule_add",
    name: "parking-fee-rule-add",
    components: {
      default: ParkingServiceNav,
      a: ParkingFeeRuleAdd
    }
  },
  {
    path: "/park_server/parking_fee_rule_modify",
    name: "parking-fee-rule-modify",
    components: {
      default: ParkingServiceNav,
      a: ParkingFeeRuleModify
    }
  },

  {
    path: "/park_server/parking_lot_area",
    name: "parking-lot-area",
    components: {
      default: ParkingServiceNav,
      a: ParkingLotArea
    }
  },
  {
    path: "/park_server/parking_lot_area_add",
    name: "parking-lot-area-add",
    components: {
      default: ParkingServiceNav,
      a: ParkingLotAreaAdd
    }
  },
  {
    path: "/park_server/parking_lot_area_modify/:id",
    name: "parking-lot-area-modify",
    components: {
      default: ParkingServiceNav,
      a: ParkingLotAreaModify
    }
  },
  {
    path: "/park_server/sentry_box_manage",
    name: "sentry-box-manage",
    components: {
      default: ParkingServiceNav,
      a: SentryBoxManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/park_server/sentry_box_add",
    name: "sentry-box-add",
    components: {
      default: ParkingServiceNav,
      a: SentryBoxAdd
    }
  },
  {
    path: "/park_server/sentry_box_modify/:id",
    name: "sentry-box-modify",
    components: {
      default: ParkingServiceNav,
      a: SentryBoxModify
    }
  },
  {
    path: "/park_server/parking_ali_account_manage",
    name: "parking-ali-account-manage",
    components: {
      default: ParkingServiceNav,
      a: ParkingAliAccountManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/park_server/parking_ali_account_add",
    name: "parking-ali-account-add",
    components: {
      default: ParkingServiceNav,
      a: ParkingAliAccountAdd
    }
  },
  {
    path: "/park_server/parking_ali_account_modify/:id",
    name: "parking-ali-account-modify",
    components: {
      default: ParkingServiceNav,
      a: ParkingAliAccountModify
    }
  },
  {
    path: "/park_server/parking_wx_account_manage",
    name: "parking-wx-account-manage",
    components: {
      default: ParkingServiceNav,
      a: ParkingWxAccountManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/park_server/parking_wx_account_add",
    name: "parking-wx-account-add",
    components: {
      default: ParkingServiceNav,
      a: ParkingWxAccountAdd
    }
  },
  {
    path: "/park_server/parking_wx_account_modify/:id",
    name: "parking-wx-account-modify",
    components: {
      default: ParkingServiceNav,
      a: ParkingWxAccountModify
    }
  },
  {
    path: "/park_server/coupon_put_on_the_shelves",
    name: "coupon-put-on-the-shelves",
    components: {
      default: ParkingServiceNav,
      a: CouponPutOnTheShelves
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/park_server/coupon_put_on_the_shelves_add",
    name: "coupon-put-on-the-shelves-add",
    components: {
      default: ParkingServiceNav,
      a: CouponPutOnTheShelvesAdd
    }
  },
  {
    path: "/park_server/coupon_put_on_the_shelves_modify/:id",
    name: "coupon-put-on-the-shelves-modify",
    components: {
      default: ParkingServiceNav,
      a: CouponPutOnTheShelvesModify
    }
  },
  {
    path: "/park_server/coupon_sell",
    name: "coupon-sell",
    components: {
      default: ParkingServiceNav,
      a: CouponSell
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/park_server/coupon_sell_add",
    name: "coupon-sell-add",
    components: {
      default: ParkingServiceNav,
      a: CouponSellAdd
    }
  },
  {
    path: "/park_server/coupon_refund",
    name: "coupon-refund",
    components: {
      default: ParkingServiceNav,
      a: CouponRefund
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/park_server/coupon_refund_add",
    name: "coupon-refund-add",
    components: {
      default: ParkingServiceNav,
      a: CouponRefundAdd
    }
  },
  {
    path: "/park_server/coupon_usage_record",
    name: "coupon-usage-record",
    components: {
      default: ParkingServiceNav,
      a: CouponUsageRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/park_server/coupon_merchant_statistics",
    name: "coupon-merchant-statistics",
    components: {
      default: ParkingServiceNav,
      a: CouponMerchantStatistics
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/park_server/free_code_record",
    name: "free-code-record",
    components: {
      default: ParkingServiceNav,
      a: FreeCodeRecord
    },
    meta: {
      keepAlive: true
    }
  },

  {
    path: "/park_server/personnel_on_duty_classes_manage",
    name: "personnel-on-duty-classes-manage",
    components: {
      default: ParkingServiceNav,
      a: PersonnelOnDutyClassesManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/park_server/personnel_on_duty_classes_add",
    name: "personnel-on-duty-classes-add",
    components: {
      default: ParkingServiceNav,
      a: PersonnelOnDutyClassesAdd
    }
  },
  {
    path: "/park_server/personnel_on_duty_classes_modify/:id",
    name: "personnel-on-duty-classes-modify",
    components: {
      default: ParkingServiceNav,
      a: PersonnelOnDutyClassesModify
    }
  },
  {
    path: "/park_server/personnel_on_duty_schedule_manage",
    name: "personnel-on-duty-schedule-manage",
    components: {
      default: ParkingServiceNav,
      a: PersonnelOnDutyScheduleManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/park_server/personnel_on_duty_schedule_add",
    name: "personnel-on-duty-schedule-add",
    components: {
      default: ParkingServiceNav,
      a: PersonnelOnDutyScheduleAdd
    }
  },
  {
    path: "/park_server/personnel_on_duty_schedule_modify/:id",
    name: "personnel-on-duty-schedule-modify",
    components: {
      default: ParkingServiceNav,
      a: PersonnelOnDutyScheduleModify
    }
  },

  // {
  //   path: "/park_server/allow_enter",
  //   name: "allow-enter",
  //   components: {
  //     default: ParkingServiceNav,
  //     a: allowEnter
  //   },
  //   meta: {
  //     keepAlive: true
  //   }
  // },
  // {
  //   path: "/park_server/disallow_enter",
  //   name: "disallow-enter",
  //   components: {
  //     default: ParkingServiceNav,
  //     a: disallowEnter
  //   },
  //   meta: {
  //     keepAlive: true
  //   }
  // }
  /* 智慧停车 */

  // 智慧停车操作日志
  // {
  //     path: '/parking_service_log',
  //     name: 'parking-service-log',
  //     components: {
  //         default: ParkingServiceNav,
  //         a: Log
  //     }
  // },
];



// WEBPACK FOOTER //
// ./src/router/Parking.js